__webpack_require__.p = "/interactive/intel/accelerating-science-with-ai/";